import { FormikProps } from 'formik';
import * as React from 'react';
import {
  ConnectionSubForm,
  ConnectionSummary,
} from '../../components/Connection';
import { DirectDebitForm } from '../Form/Form';

interface ConnectionSectionProps {
  formikProps: FormikProps<DirectDebitForm>;
  isEdit: boolean;
  isComplete: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
  onEditClick: () => void;
}

export const ConnectionSection: React.FC<ConnectionSectionProps> = ({
  formikProps,
  isEdit,
  onPreviousClick,
  onNextClick,
  onEditClick,
  isComplete,
}) => {
  const {
    electricity: parentFormElectricity,
    gas: parentFormGas,
  } = formikProps.values.connection;

  return (
    <>
      {isEdit && (
        <ConnectionSubForm
          formikProps={formikProps}
          isEdit={isEdit}
          onPreviousClick={onPreviousClick}
          onNextClick={onNextClick}
        />
      )}
      {!isEdit && (
        <ConnectionSummary
          selectedElectricity={parentFormElectricity}
          selectedGas={parentFormGas}
          showSummaryFields={isComplete}
          onEditClick={onEditClick}
        />
      )}
    </>
  );
};
